import { render, staticRenderFns } from "./StripBar.vue?vue&type=template&id=9351fa70&scoped=true&"
import script from "./StripBar.vue?vue&type=script&lang=js&"
export * from "./StripBar.vue?vue&type=script&lang=js&"
import style0 from "./StripBar.vue?vue&type=style&index=0&id=9351fa70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9351fa70",
  null
  
)

export default component.exports